<template>
  <div class="OverlayLoading" :class="[`OverlayLoading--${type}`]">
    <Loading />
  </div>
</template>

<script setup lang="ts">
import Loading from '@/components/atoms/Loading.vue';

defineOptions({
  name: 'OverlayLoading',
});

interface Props {
  type?: 'default' | 'modal';
}

withDefaults(defineProps<Props>(), {
  type: 'default',
});
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_forward.scss' as *;
.OverlayLoading {
  position: fixed;
  left: 0;
  z-index: $service-z-index-ff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgb(255 255 255 / 40%);

  &--default {
    top: $service-unit * 12;
  }
  &--modal {
    top: 0;
  }
}
</style>
